<template>
    <div class='performance-table-filter'>
        <div class="row">
            <div class="col-8 vertical-center xl-left">
                <el-select
                    v-model="managers"
                    filterable
                    :clearable=true
                    multiple
                    collapse-tags
                    class='manager-select'
                    placeholder="Filter managers"
                    @visible-change="managerSelectChange($event)"
                    @change="checkManagerSelect($event)">
                    <el-option
                        label="All managers"
                        value="all">
                    </el-option>
                    <el-option
                        v-for="item in $store.getters['general/getStoreInterests']"
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id">
                    </el-option>
                </el-select>
                <el-select
                    v-model="stores"
                    filterable
                    :clearable=true
                    multiple
                    collapse-tags
                    placeholder="Filter stores"
                    @visible-change="storeSelectChange($event)"
                    @change="checkSelect($event)"
                    class="mobile-small store-select ml-10"
                >
                    <el-option
                        label="All stores"
                        value="all">
                    </el-option>
                    <el-option
                        label="No stores"
                        value="none">
                    </el-option>
                    <el-option
                        v-for="item in $store.getters['general/getStores']"
                        :key="item.store_id"
                        :label="item.store_name"
                        :value="item.store_id"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class='col-4 vertical-center xl-right budget-lfl-switch-container'>
                <el-radio-group v-model="type" size="medium">
                    <el-radio-button label="Budget"></el-radio-button>
                    <el-radio-button label="LY LFL"></el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="row">
            <div class="col-8 vertical-center xl-left">
                <div class="date-range-container mt-10">
                    <el-button class="date-editor-button-minus" @click="decreaseBeginWeek">-</el-button>
                    <el-date-picker
                        v-model="begin"
                        type="week"
                        format="'Week' WW-yyyy"
                        placeholder="Pick a week"
                        :picker-options=optionsBegin
                        :clearable=false
                        class="range-selector">
                    </el-date-picker>
                    <el-button class="date-editor-button-plus" @click="increaseBeginWeek">+</el-button>
                    <p class="tablet-hidden to-text">to</p>
                    <el-button class="date-editor-button-minus" @click="decreaseEndWeek">-</el-button>
                    <el-date-picker
                        v-model="end"
                        type="week"
                        format="'Week' WW-yyyy"
                        placeholder="Pick a week"
                        :clearable=false
                        :picker-options=optionsEnd
                        class="range-selector"
                    >
                    </el-date-picker>
                    <el-button class="date-editor-button-plus" @click="increaseEndWeek">+</el-button>
                    <el-dropdown class="ml-10">
                        <el-button type="primary" plain>
                            <i class="el-icon-download"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="downloadData(',')">CSV (comma)</el-dropdown-item>
                            <el-dropdown-item @click.native="downloadData(';')">CSV (semicolon)</el-dropdown-item>
                            <el-dropdown-item @click.native="downloadData('dutch')">CSV (semicolon, decimal comma)</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class='col-4 vertical-center xl-right budget-lfl-switch-container'>
                <el-radio-group v-model="storeWeek" size="medium">
                    <el-radio-button label="Store"></el-radio-button>
                    <el-radio-button label="Week"></el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <!-- <div class="row">
            <div class='col-12 vertical-center xl-right budget-lfl-switch-container'>
                <el-radio-group v-model="kpi" size="medium">
                    <el-radio-button label="KPI"></el-radio-button>
                    <el-radio-button label="No KPI"></el-radio-button>
                </el-radio-group>
            </div>
        </div> -->
    </div>
</template>

<script>
import vue from 'vue'
import { getDateOfISOWeek, arrayToCSV } from '../../functions'
var debounce = require('debounce')
export default {
    props: ['parent'],
    data () {
        return {
            stores: [],
            managers: [],
            optionsBegin: {
                firstDayOfWeek: 1,
                shortcuts: [{
                    text: 'Last month',
                    onClick (picker) {
                        // picker.$emit('pick', [new Date(), new Date()])
                        picker.$emit('pick', 'last_month_begin')
                    }
                }, {
                    text: 'Last 3 months',
                    onClick (picker) {
                        picker.$emit('pick', 'last_3_months_begin')
                    }
                }, {
                    text: 'Last 6 months',
                    onClick (picker) {
                        picker.$emit('pick', 'last_6_months_begin')
                    }
                }, {
                    text: 'This year',
                    onClick (picker) {
                        picker.$emit('pick', 'this_year_begin')
                    }
                }, {
                    text: 'Last year',
                    onClick (picker) {
                        picker.$emit('pick', 'last_year_begin')
                    }
                }]
            },
            optionsEnd: {
                firstDayOfWeek: 1,
                disabledDate: this.checkEndDate,
                shortcuts: [{
                    text: 'Last month',
                    onClick (picker) {
                        // picker.$emit('pick', [new Date(), new Date()])
                        picker.$emit('pick', 'last_month_end')
                    }
                }, {
                    text: 'Last 3 months',
                    onClick (picker) {
                        picker.$emit('pick', 'last_3_months_end')
                    }
                }, {
                    text: 'Last 6 months',
                    onClick (picker) {
                        picker.$emit('pick', 'last_6_months_end')
                    }
                }, {
                    text: 'This year',
                    onClick (picker) {
                        picker.$emit('pick', 'this_year_end')
                    }
                }, {
                    text: 'Last year',
                    onClick (picker) {
                        picker.$emit('pick', 'last_year_end')
                    }
                }]
            }
        }
    },
    computed: {
        period: {
            get () {
                let period = this.$store.state.graphFilter.period
                return period.charAt(0).toUpperCase() + period.slice(1)
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_PERIOD', value.toLowerCase())
                this.debounceInput()
            }
        },
        begin: {
            get () {
                return this.$store.state.graphFilter.performancePeriod['begin']
            },
            set (value) {
                value = this.checkPickerValue('begin', value)
                this.$store.commit('graphFilter/UPDATE_PERFORMANCE_PERIOD', { value: value, type: 'begin' })
                this.debounceInput()
            }
        },
        end: {
            get () {
                return this.$store.state.graphFilter.performancePeriod['end']
            },
            set (value) {
                value = this.checkPickerValue('end', value)
                this.$store.commit('graphFilter/UPDATE_PERFORMANCE_PERIOD', { value: value, type: 'end' })
                this.debounceInput()
            }
        },
        type: {
            get () {
                return this.$store.state.graphFilter.performanceType
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_PERFORMANCE_TYPE', value)
                this.debounceInput()
            }
        },
        storeWeek: {
            get () {
                return this.$store.state.graphFilter.performanceStoreWeek
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_PERFORMANCE_STORE_WEEK_TYPE', value)
                this.debounceInput()
            }
        },
        kpi: {
            get () {
                return this.$store.state.graphFilter.performanceKPI
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_PERFORMANCE_KPI', value)
                this.debounceInput()
            }
        }
    },
    methods: {
        downloadData (sep) {
            // Merge data with total row
            let d = JSON.parse(JSON.stringify(this.$store.state.budget.analyticsTable))
            d.push(this.$store.state.budget.analyticsTotalTable[0])
            // Get store names and if dutch then replace . with ,
            for (let idx in d) {
                for (let key of Object.keys(d[idx])) {
                    if (sep === 'dutch') {
                        d[idx][key] = String(d[idx][key])
                        d[idx][key] = d[idx][key].replace(',', '')
                        d[idx][key] = d[idx][key].replace('.', ',')
                    }
                }
            }
            // Replacing done so now set seperator to ;
            if (sep === 'dutch') {
                sep = ';'
            }
            // Convert to csv and download
            let csv = arrayToCSV(d, sep)
            let data = encodeURI('data:text/csv;charset=utf-8,' + csv)
            const link = document.createElement('a')
            link.setAttribute('href', data)
            var today = new Date()
            var dd = today.getDate()
            var mm = today.getMonth() + 1
            var yyyy = today.getFullYear()
            link.setAttribute('download', 'cost_analytics_' + String(dd) + '_' + String(mm) + '_' + String(yyyy) + '.csv')
            link.click()
        },
        debounceInput: debounce(
            function () {
                this.$emit('filterChanged')
            }, 500),
        getQueryParameters () {
            for (let param in this.$route.query) {
                if (param === 'store_ids') {
                    this.stores = []
                    let storeIds = this.$route.query[param].split(',')
                    for (let idx in storeIds) {
                        if (storeIds[idx] === '') {
                            storeIds.splice(idx, 1)
                        } else {
                            this.stores.push(parseInt(storeIds[idx]))
                        }
                    }
                    this.storeSelectChange(false)
                } else if (param === 'store_id') {
                    this.stores = [parseInt(this.$route.query[param])]
                    this.storeSelectChange(false)
                    this.$emit('filterChanged')
                } else if (param === 'begin') {
                    this.begin = getDateOfISOWeek(this.$route.query[param].split('-')[0], this.$route.query[param].split('-')[1])
                } else if (param === 'end') {
                    this.end = getDateOfISOWeek(this.$route.query[param].split('-')[0], this.$route.query[param].split('-')[1])
                } else if (param === 'week') {
                    let week = parseInt(this.$route.query['week'])
                    let year = parseInt(this.$route.query['year'])
                    this.begin = getDateOfISOWeek(week, year)
                    this.end = getDateOfISOWeek(week, year)
                } else if (param === 'lfl') {
                    if (this.$route.query[param] === true) {
                        this.type = 'LY LFL'
                    } else {
                        this.type = 'Budget'
                    }
                }
            }
        },
        checkPickerValue (type, value) {
            let year = new Date().getFullYear()
            let lastYear = year - 1
            let month = new Date().getMonth()
            if (month < 10) {
                month = '0' + String(month)
            }

            if (type === 'begin') {
                if (value === 'last_month_begin') {
                    this.end = new Date(String(year) + '-' + String(month) + '-30')
                    return new Date(String(year) + '-' + String(month) + '-01')
                } else if (value === 'last_3_months_begin') {
                    let d = new Date()
                    d.setMonth(d.getMonth() - 2)
                    this.end = new Date(String(year) + '-' + String(month) + '-30')
                    return new Date(String(d.getFullYear()) + '-' + String(d.getMonth()) + '-01')
                } else if (value === 'last_6_months_begin') {
                    let d = new Date()
                    d.setMonth(d.getMonth() - 5)
                    this.end = new Date(String(year) + '-' + String(month) + '-30')
                    return new Date(String(d.getFullYear()) + '-' + String(d.getMonth()) + '-01')
                } else if (value === 'this_year_begin') {
                    this.end = new Date(String(year) + '-12-30')
                    return new Date(String(year) + '-01-01')
                } else if (value === 'last_year_begin') {
                    this.end = new Date(String(lastYear) + '-12-30')
                    return new Date(String(lastYear) + '-01-01')
                }
            } else if (type === 'end') {
                if (value === 'last_month_end') {
                    this.begin = new Date(String(year) + '-' + String(month) + '-01')
                    return new Date(String(year) + '-' + String(month) + '-30')
                } else if (value === 'last_3_months_end') {
                    let d = new Date()
                    d.setMonth(d.getMonth() - 2)
                    this.begin = new Date(String(d.getFullYear()) + '-' + String(d.getMonth()) + '-01')
                    return new Date(String(year) + '-' + String(month) + '-30')
                } else if (value === 'last_6_months_end') {
                    let d = new Date()
                    d.setMonth(d.getMonth() - 5)
                    this.begin = new Date(String(d.getFullYear()) + '-' + String(d.getMonth()) + '-01')
                    return new Date(String(year) + '-' + String(month) + '-30')
                } else if (value === 'this_year_end') {
                    this.begin = new Date(String(year) + '-01-01')
                    return new Date(String(year) + '-12-30')
                } else if (value === 'last_year_end') {
                    this.begin = new Date(String(lastYear) + '-01-01')
                    return new Date(String(lastYear) + '-12-30')
                }
            }
            return value
        },
        checkManagerSelect (managers) {
            if (managers.includes('all')) {
                this.managers = this.$store.getters['general/getStoreInterests'].map(s => s.user_id)
            }
        },
        managerSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the
                let data = []
                for (let m of this.managers) {
                    let stores = this.$store.state.general.storeInterests.find(x => x.user_id === m)['stores']
                    if (stores !== null && stores.length > 0) {
                        data.push(...stores)
                    }
                }
                data = Array.from(new Set(data))
                this.stores = data
                this.$store.dispatch('graphFilter/updateStores', { 'stores': data })
                this.$emit('filterChanged')
            }
        },
        checkEndDate (time) {
            if (time.getTime() < this.begin) {
                return true
            } else {
                return false
            }
        },
        storeSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the graphs
                if (this.stores.includes('all')) {
                    this.stores = this.$store.getters['general/getStores'].map(s => s.store_id)
                }
                this.$store.dispatch('graphFilter/updateStores', { 'stores': this.stores })
                this.$emit('filterChanged')
            }
        },
        checkSelect (stores) {
            if (stores.includes('all')) {
                this.stores = this.$store.getters['general/getStores'].map(s => s.store_id)
            } else if (stores.includes('none')) {
                this.stores = []
            }
        },
        increaseBeginWeek () {
            if (this.$store.state.graphFilter.performancePeriod.end.getTime() - this.$store.state.graphFilter.performancePeriod.begin.getTime() > 0) {
                vue.set(this.$store.state.graphFilter.performancePeriod, 'begin', new Date(this.$store.state.graphFilter.performancePeriod.begin.getTime() + 24 * 60 * 60 * 1000 * 7))
                this.debounceInput()
            }
        },
        decreaseBeginWeek () {
            vue.set(this.$store.state.graphFilter.performancePeriod, 'begin', new Date(this.$store.state.graphFilter.performancePeriod.begin.getTime() - 24 * 60 * 60 * 1000 * 7))
            this.debounceInput()
        },
        increaseEndWeek () {
            vue.set(this.$store.state.graphFilter.performancePeriod, 'end', new Date(this.$store.state.graphFilter.performancePeriod.end.getTime() + 24 * 60 * 60 * 1000 * 7))
            this.debounceInput()
        },
        decreaseEndWeek () {
            if (this.$store.state.graphFilter.performancePeriod.end.getTime() - this.$store.state.graphFilter.performancePeriod.begin.getTime() > 0) {
                vue.set(this.$store.state.graphFilter.performancePeriod, 'end', new Date(this.$store.state.graphFilter.performancePeriod.end.getTime() - 24 * 60 * 60 * 1000 * 7))
                this.debounceInput()
            }
        }
    },
    created () {
        let promiseList = [this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getStoreInterests')]
        Promise.all(promiseList).then(response => {
            this.stores = this.$store.state.general.storeInterests.find(x => x.user_id === parseInt(localStorage.getItem('user_id')))['stores']
            this.managers = [parseInt(localStorage.getItem('user_id'))]
            this.$store.dispatch('graphFilter/updateStores', { 'stores': this.stores, 'initialLoad': true }).then(response => {
                this.loaded = true
                this.$emit('filterLoaded')
                this.getQueryParameters()
            })
        })
    }
}
</script>

<style lang="scss">
.performance-table-filter {
    .manager-select {
        width: 200px;
    }
    .store-select {
        width: 250px;
    }
    .type-select {
        width: 150px;
    }
    .el-date-editor  {
        width: 130px !important;
    }
    @media(max-width: 1200px) {
        .budget-lfl-switch-container {
            padding-top: 10px;
        }
    }
    @media(max-width: 768px) {
        .type-select {
            width: 250px;
        }
    }

    .range-selector {
        min-width: 150px !important;
    }
    .el-input--prefix .el-input__inner{
        padding-left: 30px;
    }
    .el-input--suffix .el-input__inner {
        padding-right: 20px;
    }
        .date-editor-button-plus {
        border-radius: 0;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: none;
    }
    .date-editor-button-minus {
        border-radius: 0;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-right: none;
    }
    .date-editor-button-minus:hover {
        background-color: #fff;
    }
    .date-editor-button-plus:hover, .date-editor-button-plus:active , .date-editor-button-plus:focus, .date-editor-button-minus:hover, .date-editor-button-minus:active , .date-editor-button-minus:focus {
        background-color: #fff;
        border-color: #DCDFE6;
        outline: none !important;
        box-shadow: none !important;
        color: #606266;
    }
    .date-editor-button-plus:hover, .date-editor-button-minus:hover {
        color: #409EFF;
    }
    .el-date-editor {
        .el-input__inner {
            border-radius: 0;
        }
        .el-input__inner:focus, .el-input__inner:hover {
            border-color: #DCDFE6;
        }
    }
    @media(max-width: 768px) {
        .date-editor-button-minus, .date-editor-button-plus {
            display: none !important;
        }
    }
    @media(max-width: 992px) {
        .date-editor-button-minus {
            margin-left: 5px;
        }
    }
    @media(max-width: 947px) {
       .range-selector {
           margin-top: 10px;
       }
    }
    p.to-text {
        margin: 0px 5px;
        display: inline;
        line-height: 2.4;
    }
    .el-radio-group {
        .el-radio-button__inner {
            width: 100px;
        }
    }
}
</style>
